import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AttendenceExportService } from '../../../attendance-export.service';
import { AttendenceExportModel } from '../../../models/attendence-export.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { MatDialogModule } from '@angular/material/dialog';



@Component({
  selector: 'app-edit-employee-payroll-code',
  standalone: false,
  templateUrl: './edit-employee-payroll-code.component.html',
  styleUrls: ['./edit-employee-payroll-code.component.scss']
})
export class EditEmployeePayrollCodeComponent implements OnInit, DirtyCheck {
  title: string = "Employee Payroll Details";
  editForm: FormGroup;
  employeePayrollInfo: AttendenceExportModel = {};
  isFormDirty: boolean = false;

  constructor(
    private builder: FormBuilder,
    private validatePayrollCodeService: AttendenceExportService,
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<EditEmployeePayrollCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editForm = this.builder.group({
      code: [''],
      category_name: [''],
      department_name: [''],
      payroll_code: ['', [Validators.required, Validators.maxLength(7)]],
      fixed_pay: [false]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.setEmployeePayrollInfoFromData();
    }
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.dialogRef.close(false); // Close dialog on cancel/discard
  }

  setEmployeePayrollInfoFromData(): void {
    const payload = {
      payroll_group_id: this.data.payroll_group_id,
      year: this.data.year,
      weekNo: this.data.weekNo,
      employee_id: this.data.employee_id,
      shop_id: this.data.shop_id
    };

    this.validatePayrollCodeService.getById(payload).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          this.employeePayrollInfo = response.data.payroll_attendance?.[0] ?? {};
          this.editForm.patchValue({
            code: this.employeePayrollInfo.code || '',
            category_name: this.employeePayrollInfo.category_name || '',
            department_name: this.employeePayrollInfo.department_name || '',
            payroll_code: this.employeePayrollInfo.payroll_code || '',
            fixed_pay: this.employeePayrollInfo.export === 1
          });
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({
            message: response.message || 'Failed to load data',
            title: 'Error',
            type: 'error'
          });
        }
      },
      error: (error) => {
        this.snackBarService.openSnackBar({
          message: 'Failed to connect to server.',
          title: 'Error',
          type: 'error'
        });
      }
    });
  }

  getTitle(): string {
    if (!this.employeePayrollInfo || !this.employeePayrollInfo.employee_id) {
      return "Employee Payroll Details";
    }
    return `Editing: ${this.employeePayrollInfo.f_name || ''} ${this.employeePayrollInfo.l_name || ''}`.trim() || "Employee Payroll Details";
  }

  save(): void {
    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      this.snackBarService.openSnackBar({
        message: 'Please fill all required fields.',
        title: 'Validation Error',
        type: 'error'
      });
      return;
    }

    const payload = {
      employee_id: this.employeePayrollInfo.employee_id,
      payroll_code: this.editForm.value.payroll_code?.trim(),
      fixed_pay: this.editForm.value.fixed_pay ? 1 : 0,
      shop_id: this.data.shop_id
    };

    this.validatePayrollCodeService.update(payload).subscribe({
      next: (response) => {
        if (response.status === 'SUCCESS') {
          this.isFormDirty = false;
          this.snackBarService.openSnackBar({
            type: 'success',
            title: 'Success',
            message: 'Payroll details updated successfully.'
          });
          this.dialogRef.close(true); // Close dialog and return success
        } else {
          this.snackBarService.openSnackBar({
            message: response.message || 'Update failed',
            title: 'Error',
            type: 'error'
          });
        }
      },
      error: (err) => {
        console.error('Update error:', err);
        this.snackBarService.openSnackBar({
          message: 'Failed to update. Please try again.',
          title: 'Error',
          type: 'error'
        });
      }
    });
  }
}